/* eslint-disable no-unused-vars */
export const palette = {
  '--pf-v5-global--palette--black-100': '#fafafa',
  '--pf-v5-global--palette--black-150': '#f5f5f5',
  '--pf-v5-global--palette--black-200': '#f0f0f0',
  '--pf-v5-global--palette--black-300': '#d2d2d2',
  '--pf-v5-global--palette--black-400': '#b8bbbe',
  '--pf-v5-global--palette--black-500': '#8a8d90',
  '--pf-v5-global--palette--black-600': '#6a6e73',
  '--pf-v5-global--palette--black-700': '#4f5255',
  '--pf-v5-global--palette--black-800': '#3c3f42',
  '--pf-v5-global--palette--black-850': '#212427',
  '--pf-v5-global--palette--black-900': '#151515',
  '--pf-v5-global--palette--black-1000': '#030303',
  '--pf-v5-global--palette--blue-50': '#e7f1fa',
  '--pf-v5-global--palette--blue-100': '#bee1f4',
  '--pf-v5-global--palette--blue-200': '#73bcf7',
  '--pf-v5-global--palette--blue-300': '#2b9af3',
  '--pf-v5-global--palette--blue-400': '#06c',
  '--pf-v5-global--palette--blue-500': '#004080',
  '--pf-v5-global--palette--blue-600': '#002952',
  '--pf-v5-global--palette--blue-700': '#001223',
  '--pf-v5-global--palette--cyan-50': '#f2f9f9',
  '--pf-v5-global--palette--cyan-100': '#a2d9d9',
  '--pf-v5-global--palette--cyan-200': '#73c5c5',
  '--pf-v5-global--palette--cyan-300': '#009596',
  '--pf-v5-global--palette--cyan-400': '#005f60',
  '--pf-v5-global--palette--cyan-500': '#003737',
  '--pf-v5-global--palette--cyan-600': '#002323',
  '--pf-v5-global--palette--cyan-700': '#000f0f',
  '--pf-v5-global--palette--gold-50': '#fdf7e7',
  '--pf-v5-global--palette--gold-100': '#f9e0a2',
  '--pf-v5-global--palette--gold-200': '#f6d173',
  '--pf-v5-global--palette--gold-300': '#f4c145',
  '--pf-v5-global--palette--gold-400': '#f0ab00',
  '--pf-v5-global--palette--gold-500': '#c58c00',
  '--pf-v5-global--palette--gold-600': '#795600',
  '--pf-v5-global--palette--gold-700': '#3d2c00',
  '--pf-v5-global--palette--green-50': '#f3faf2',
  '--pf-v5-global--palette--green-100': '#bde5b8',
  '--pf-v5-global--palette--green-200': '#95d58e',
  '--pf-v5-global--palette--green-300': '#6ec664',
  '--pf-v5-global--palette--green-400': '#5ba352',
  '--pf-v5-global--palette--green-500': '#3e8635',
  '--pf-v5-global--palette--green-600': '#1e4f18',
  '--pf-v5-global--palette--green-700': '#0f280d',
  '--pf-v5-global--palette--light-blue-100': '#beedf9',
  '--pf-v5-global--palette--light-blue-200': '#7cdbf3',
  '--pf-v5-global--palette--light-blue-300': '#35caed',
  '--pf-v5-global--palette--light-blue-400': '#00b9e4',
  '--pf-v5-global--palette--light-blue-500': '#008bad',
  '--pf-v5-global--palette--light-blue-600': '#005c73',
  '--pf-v5-global--palette--light-blue-700': '#002d39',
  '--pf-v5-global--palette--light-green-100': '#e4f5bc',
  '--pf-v5-global--palette--light-green-200': '#c8eb79',
  '--pf-v5-global--palette--light-green-300': '#ace12e',
  '--pf-v5-global--palette--light-green-400': '#92d400',
  '--pf-v5-global--palette--light-green-500': '#6ca100',
  '--pf-v5-global--palette--light-green-600': '#486b00',
  '--pf-v5-global--palette--light-green-700': '#253600',
  '--pf-v5-global--palette--orange-50': '#fff6ec',
  '--pf-v5-global--palette--orange-100': '#f4b678',
  '--pf-v5-global--palette--orange-200': '#ef9234',
  '--pf-v5-global--palette--orange-300': '#ec7a08',
  '--pf-v5-global--palette--orange-400': '#c46100',
  '--pf-v5-global--palette--orange-500': '#8f4700',
  '--pf-v5-global--palette--orange-600': '#773d00',
  '--pf-v5-global--palette--orange-700': '#3b1f00',
  '--pf-v5-global--palette--purple-50': '#f2f0fc',
  '--pf-v5-global--palette--purple-100': '#cbc1ff',
  '--pf-v5-global--palette--purple-200': '#b2a3ff',
  '--pf-v5-global--palette--purple-300': '#a18fff',
  '--pf-v5-global--palette--purple-400': '#8476d1',
  '--pf-v5-global--palette--purple-500': '#6753ac',
  '--pf-v5-global--palette--purple-600': '#40199a',
  '--pf-v5-global--palette--purple-700': '#1f0066',
  '--pf-v5-global--palette--red-50': '#faeae8',
  '--pf-v5-global--palette--red-100': '#c9190b',
  '--pf-v5-global--palette--red-200': '#a30000',
  '--pf-v5-global--palette--red-300': '#7d1007',
  '--pf-v5-global--palette--red-400': '#470000',
  '--pf-v5-global--palette--red-500': '#2c0000',
  '--pf-v5-global--palette--white': '#fff'
};

export const colors = {
  '--pf-v5-global--BackgroundColor--100': '#fff',
  '--pf-v5-global--BackgroundColor--150': '#fafafa',
  '--pf-v5-global--BackgroundColor--200': '#f0f0f0',
  '--pf-v5-global--BackgroundColor--light-100': '#fff',
  '--pf-v5-global--BackgroundColor--light-200': '#fafafa',
  '--pf-v5-global--BackgroundColor--light-300': '#f0f0f0',
  '--pf-v5-global--BackgroundColor--dark-100': '#151515',
  '--pf-v5-global--BackgroundColor--dark-200': '#3c3f42',
  '--pf-v5-global--BackgroundColor--dark-300': '#212427',
  '--pf-v5-global--BackgroundColor--dark-400': '#4f5255',
  '--pf-v5-global--BackgroundColor--dark-transparent-100': 'rgba(3, 3, 3, 0.62)',
  '--pf-v5-global--BackgroundColor--dark-transparent-200': 'rgba(3, 3, 3, 0.32)',
  '--pf-v5-global--Color--100': '#151515',
  '--pf-v5-global--Color--200': '#6a6e73',
  '--pf-v5-global--Color--300': '#3c3f42',
  '--pf-v5-global--Color--400': '#8a8d90',
  '--pf-v5-global--Color--light-100': '#fff',
  '--pf-v5-global--Color--light-200': '#f0f0f0',
  '--pf-v5-global--Color--light-300': '#d2d2d2',
  '--pf-v5-global--Color--dark-100': '#151515',
  '--pf-v5-global--Color--dark-200': '#6a6e73',
  '--pf-v5-global--active-color--100': '#06c',
  '--pf-v5-global--active-color--200': '#bee1f4',
  '--pf-v5-global--active-color--300': '#2b9af3',
  '--pf-v5-global--active-color--400': '#73bcf7',
  '--pf-v5-global--disabled-color--100': '#6a6e73',
  '--pf-v5-global--disabled-color--200': '#d2d2d2',
  '--pf-v5-global--disabled-color--300': '#f0f0f0',
  '--pf-v5-global--primary-color--100': '#06c',
  '--pf-v5-global--primary-color--200': '#004080',
  '--pf-v5-global--primary-color--light-100': '#73bcf7',
  '--pf-v5-global--primary-color--dark-100': '#06c',
  '--pf-v5-global--secondary-color--100': '#6a6e73',
  '--pf-v5-global--default-color--100': '#73c5c5',
  '--pf-v5-global--default-color--200': '#009596',
  '--pf-v5-global--default-color--300': '#003737',
  '--pf-v5-global--success-color--100': '#3e8635',
  '--pf-v5-global--success-color--200': '#1e4f18',
  '--pf-v5-global--info-color--100': '#2b9af3',
  '--pf-v5-global--info-color--200': '#002952',
  '--pf-v5-global--warning-color--100': '#f0ab00',
  '--pf-v5-global--warning-color--200': '#795600',
  '--pf-v5-global--danger-color--100': '#c9190b',
  '--pf-v5-global--danger-color--200': '#a30000',
  '--pf-v5-global--danger-color--300': '#470000',
  '--pf-v5-global--link--Color': '#06c',
  '--pf-v5-global--link--Color--hover': '#004080',
  '--pf-v5-global--link--Color--light': '#2b9af3',
  '--pf-v5-global--link--Color--light--hover': '#73bcf7',
  '--pf-v5-global--link--Color--dark': '#06c',
  '--pf-v5-global--link--Color--dark--hover': '#004080',
  '--pf-v5-global--link--Color--visited': '#40199a',
  '--pf-v5-global--BorderColor--100': '#d2d2d2',
  '--pf-v5-global--BorderColor--200': '#8a8d90',
  '--pf-v5-global--BorderColor--300': '#f0f0f0',
  '--pf-v5-global--BorderColor--dark-100': '#d2d2d2',
  '--pf-v5-global--BorderColor--light-100': '#b8bbbe',
  '--pf-v5-global--icon--Color--light': '#6a6e73',
  '--pf-v5-global--icon--Color--dark': '#151515'
};

const originalBoxShadow = {
  '--pf-v5-global--BoxShadow--sm': '0 0.0625rem 0.125rem 0 rgba(3, 3, 3, 0.12), 0 0 0.125rem 0 rgba(3, 3, 3, 0.06)',
  '--pf-v5-global--BoxShadow--sm-top': '0 -0.125rem 0.25rem -0.0625rem rgba(3, 3, 3, 0.16)',
  '--pf-v5-global--BoxShadow--sm-right': '0.125rem 0 0.25rem -0.0625rem rgba(3, 3, 3, 0.16)',
  '--pf-v5-global--BoxShadow--sm-bottom': '0 0.125rem 0.25rem -0.0625rem rgba(3, 3, 3, 0.16)',
  '--pf-v5-global--BoxShadow--sm-left': '-0.125rem 0 0.25rem -0.0625rem rgba(3, 3, 3, 0.16)',
  '--pf-v5-global--BoxShadow--md': '0 0.25rem 0.5rem 0rem rgba(3, 3, 3, 0.12), 0 0 0.25rem 0 rgba(3, 3, 3, 0.06)',
  '--pf-v5-global--BoxShadow--md-top': '0 -0.5rem 0.5rem -0.375rem rgba(3, 3, 3, 0.18)',
  '--pf-v5-global--BoxShadow--md-right': '0.5rem 0 0.5rem -0.375rem rgba(3, 3, 3, 0.18)',
  '--pf-v5-global--BoxShadow--md-bottom': '0 0.5rem 0.5rem -0.375rem rgba(3, 3, 3, 0.18)',
  '--pf-v5-global--BoxShadow--md-left': '-0.5rem 0 0.5rem -0.375rem rgba(3, 3, 3, 0.18)',
  '--pf-v5-global--BoxShadow--lg': '0 0.5rem 1rem 0 rgba(3, 3, 3, 0.16), 0 0 0.375rem 0 rgba(3, 3, 3, 0.08)',
  '--pf-v5-global--BoxShadow--lg-top': '0 -0.75rem 0.75rem -0.5rem rgba(3, 3, 3, 0.18)',
  '--pf-v5-global--BoxShadow--lg-right': '0.75rem 0 0.75rem -0.5rem rgba(3, 3, 3, 0.18)',
  '--pf-v5-global--BoxShadow--lg-bottom': '0 0.75rem 0.75rem -0.5rem rgba(3, 3, 3, 0.18)',
  '--pf-v5-global--BoxShadow--lg-left': '-0.75rem 0 0.75rem -0.5rem rgba(3, 3, 3, 0.18)',
  '--pf-v5-global--BoxShadow--xl': '0 1rem 2rem 0 rgba(3, 3, 3, 0.16), 0 0 0.5rem 0 rgba(3, 3, 3, 0.1)',
  '--pf-v5-global--BoxShadow--xl-top': '0 -1rem 1rem -0.5rem rgba(3, 3, 3, 0.2)',
  '--pf-v5-global--BoxShadow--xl-right': '1rem 0 1rem -0.5rem rgba(3, 3, 3, 0.2)',
  '--pf-v5-global--BoxShadow--xl-bottom': '0 1rem 1rem -0.5rem rgba(3, 3, 3, 0.2)',
  '--pf-v5-global--BoxShadow--xl-left': '-1rem 0 1rem -0.5rem rgba(3, 3, 3, 0.2)',
  '--pf-v5-global--BoxShadow--inset': 'inset 0 0 0.625rem 0 rgba(3, 3, 3, 0.25)'
};
const fontPath = {
  '--pf-v5-global--font-path': '"./assets/fonts"',
  '--pf-v5-global--fonticon-path': '"./assets/pficon"'
};
const spacer = {
  '--pf-v5-global--spacer--xs': '0.25rem',
  '--pf-v5-global--spacer--sm': '0.5rem',
  '--pf-v5-global--spacer--md': '1rem',
  '--pf-v5-global--spacer--lg': '1.5rem',
  '--pf-v5-global--spacer--xl': '2rem',
  '--pf-v5-global--spacer--2xl': '3rem',
  '--pf-v5-global--spacer--3xl': '4rem',
  '--pf-v5-global--spacer--4xl': '5rem',
  '--pf-v5-global--spacer--form-element': '0.375rem',
  '--pf-v5-global--gutter': '1rem',
  '--pf-v5-global--gutter--md': '1.5rem'
};
const zIndex = {
  '--pf-v5-global--ZIndex--xs': '100',
  '--pf-v5-global--ZIndex--sm': '200',
  '--pf-v5-global--ZIndex--md': '300',
  '--pf-v5-global--ZIndex--lg': '400',
  '--pf-v5-global--ZIndex--xl': '500',
  '--pf-v5-global--ZIndex--2xl': '600'
};
const breakpoint = {
  '--pf-v5-global--breakpoint--xs': '0',
  '--pf-v5-global--breakpoint--sm': '576px',
  '--pf-v5-global--breakpoint--md': '768px',
  '--pf-v5-global--breakpoint--lg': '992px',
  '--pf-v5-global--breakpoint--xl': '1200px',
  '--pf-v5-global--breakpoint--2xl': '1450px'
};
const heightBreakpoint = {
  '--pf-v5-global--height-breakpoint--sm': '0',
  '--pf-v5-global--height-breakpoint--md': '40rem',
  '--pf-v5-global--height-breakpoint--lg': '48rem',
  '--pf-v5-global--height-breakpoint--xl': '60rem',
  '--pf-v5-global--height-breakpoint--2xl': '80rem'
};

const textDecoration = {
  '--pf-v5-global--link--TextDecoration': 'none',
  '--pf-v5-global--link--TextDecoration--hover': 'underline'
};
const borderWidth = {
  '--pf-v5-global--BorderWidth--sm': '1px',
  '--pf-v5-global--BorderWidth--md': '2px',
  '--pf-v5-global--BorderWidth--lg': '3px',
  '--pf-v5-global--BorderWidth--xl': '4px',
  '--pf-v5-global--BorderRadius--sm': '3px',
  '--pf-v5-global--BorderRadius--lg': '30em'
};

const font = {
  '--pf-v5-global--icon--FontSize--sm': '0.625rem',
  '--pf-v5-global--icon--FontSize--md': '1.125rem',
  '--pf-v5-global--icon--FontSize--lg': '1.5rem',
  '--pf-v5-global--icon--FontSize--xl': '3.375rem',
  '--pf-v5-global--FontFamily--sans-serif': '"RedHatText", "Overpass", overpass, helvetica, arial, sans-serif',
  '--pf-v5-global--FontFamily--heading--sans-serif': '"RedHatDisplay", "Overpass", overpass, helvetica, arial, sans-serif',
  '--pf-v5-global--FontFamily--monospace': '"Liberation Mono", consolas, "SFMono-Regular", menlo, monaco, "Courier New", monospace',
  '--pf-v5-global--FontFamily--redhat-updated--sans-serif': '"RedHatTextUpdated", "Overpass", overpass, helvetica, arial, sans-serif',
  '--pf-v5-global--FontFamily--redhat-updated--heading--sans-serif': '"RedHatDisplayUpdated", "Overpass", overpass, helvetica, arial, sans-serif',
  '--pf-v5-global--FontFamily--redhat--monospace': '"RedHatMono", "Liberation Mono", consolas, "SFMono-Regular", menlo, monaco, "Courier New", monospace',
  '--pf-v5-global--FontFamily--redhatVF--sans-serif': '"RedHatTextVF", "RedHatText", "Overpass", overpass, helvetica, arial, sans-serif',
  '--pf-v5-global--FontFamily--redhatVF--heading--sans-serif': '"RedHatDisplayVF", "RedHatDisplay", "Overpass", overpass, helvetica, arial, sans-serif',
  '--pf-v5-global--FontFamily--redhatVF--monospace': '"RedHatMonoVF", "RedHatMono", "Liberation Mono", consolas, "SFMono-Regular", menlo, monaco, "Courier New", monospace',
  '--pf-v5-global--FontFamily--overpass--sans-serif': '"overpass", overpass, "open sans", -apple-system, blinkmacsystemfont, "Segoe UI", roboto, "Helvetica Neue", arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  '--pf-v5-global--FontFamily--overpass--monospace': '"overpass-mono", overpass-mono, "SFMono-Regular", menlo, monaco, consolas, "Liberation Mono", "Courier New", monospace',
  '--pf-v5-global--FontSize--4xl': '2.25rem',
  '--pf-v5-global--FontSize--3xl': '1.75rem',
  '--pf-v5-global--FontSize--2xl': '1.5rem',
  '--pf-v5-global--FontSize--xl': '1.25rem',
  '--pf-v5-global--FontSize--lg': '1.125rem',
  '--pf-v5-global--FontSize--md': '1rem',
  '--pf-v5-global--FontSize--sm': '0.875rem',
  '--pf-v5-global--FontSize--xs': '0.75rem',
  '--pf-v5-global--FontWeight--light': '300',
  '--pf-v5-global--FontWeight--normal': '400',
  '--pf-v5-global--FontWeight--semi-bold': '700',
  '--pf-v5-global--FontWeight--overpass--semi-bold': '500',
  '--pf-v5-global--FontWeight--bold': '700',
  '--pf-v5-global--FontWeight--overpass--bold': '600',
  '--pf-v5-global--LineHeight--sm': '1.3',
  '--pf-v5-global--LineHeight--md': '1.5'
};

const other = {
  '--pf-v5-global--ListStyle': 'disc outside',
  '--pf-v5-global--Transition': 'all 250ms cubic-bezier(0.42, 0, 0.58, 1)',
  '--pf-v5-global--TimingFunction': 'cubic-bezier(0.645, 0.045, 0.355, 1)',
  '--pf-v5-global--TransitionDuration': '250ms',
  '--pf-v5-global--arrow--width': '0.9375rem',
  '--pf-v5-global--arrow--width-lg': '1.5625rem',
  '--pf-v5-global--target-size--MinWidth': '44px',
  '--pf-v5-global--target-size--MinHeight': '44px'
};

